export default __webpack_public_path__ + "static/media/solution.0dd7d214.png";